import { Component, OnInit } from '@angular/core';
import { TasksService } from '../../core/services/tasks.service';
import { Router, ActivatedRoute } from '@angular/router';
import { UiService } from '../../core/services/ui.service';
import { UsersService } from '../../core/services/users.service';
import { ProjectsService } from '../../core/services/projects.service';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'tasks-create',
  templateUrl: 'tasks-create-edit.template.html',
})
export class TasksCreateComponent implements OnInit {
  private task;
  private usersOpts = [];
  private projectsOpts = [];
  private taskUser: {
    text: string;
    initialId: number;
  };
  public isLoading: boolean;
  constructor(
    private tasksSrv: TasksService,
    private usersSrv: UsersService,
    private projectsSrv: ProjectsService,
    private route: ActivatedRoute,
    private router: Router,
    private ui: UiService
  ) {
    this.taskUser = {
      text: null,
      initialId: null,
    };
  }

  ngOnInit() {
    this.ui.toolbar.title = 'Nueva Tarea';
    this.task = this.tasksSrv.create();
    this.fetch();
  }

  fetch() {
    this.isLoading = true;
    Promise.all([this.usersSrv.fetch(), this.projectsSrv.projectsNoPagination()])
      .then(([users, projects]) => {
        this.usersListHandler(users);
        this.projectsListHandler(projects);
        this.isLoading = false;
      })
      .catch((err) => {
        this.ui.snackbar.show({
          message: 'Ocurrió un error cargando los datos',
        });
        this.isLoading = false;
      });
  }

  usersListHandler(userCollection: any) {
    this.usersOpts = userCollection
      .filter((user) => user.status === 'active')
      .asObjectOptions('id', { orderBy: 'email' });
  }

  projectsListHandler(projectCollection: any) {
    this.projectsOpts = projectCollection.asOptions('id', 'name', { orderBy: 'name' });
  }

  handleSubmit(evt) {
    evt.preventDefault();
    this.saveTask();
  }

  saveTask() {
    this.tasksSrv.save(this.task).then((task) => {
      this.ui.snackbar.show({
        message: 'Tarea creada!',
      });
      this.router.navigate(['/tasks/tasks/' + task.id]);
    });
  }

  taskUserChangeHandler(id: number) {
    this.task.user_id = id;
  }
}
